import React from 'react'
import { useNavigate } from 'react-router-dom'
import './NotFoundPage.css'
import Button from "@mui/material/Button"

const NotFoundPage = () => {
  const navigate = useNavigate()

  return (
    <div className="not-found-page">
      <div className="not-found-content">
        <h1 className="error-code">404</h1>
        <h2 className="error-title">Not found</h2>
        <p className="error-description">
          Unfortunately, the requested page does not exist or was deleted.
        </p>

        <Button
          color="primary"
          variant="contained"
          onClick={() => navigate("/")}
          sx={{ fontFamily: "RUSBoycott, sans-serif" }}
        >
          Return to Home page
        </Button>
      </div>
    </div>
  )
}

export default NotFoundPage
